module.exports = __webpack_public_path__ + "static/media/team_amber.292f9e26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/team_amber.svg
// module id = 1091
// module chunks = 2